import React from 'react';

// template components

// styles
import { RelatedLinksStyled } from './styles';

export default () => {
  const linkItems = [
    {
      linkUrl: '/assets/pdf/northwestern-mutual-fact-sheet.pdf',
      linkId: 'related-links-fact-sheet',
      linkText: 'Fact Sheet',
      isOutgoingLink: true,
      children: '',
    },
    {
      linkUrl: '/assets/pdf/brochures/our-mutual-advantage.pdf',
      linkId: 'related-links-our-mutual-advantage',
      linkText: 'Our Mutual Advantage',
      isOutgoingLink: true,
      children: '',
    },
    {
      linkUrl: '/2022-annual-report/',
      linkId: 'related-links-annual-report',
      linkText: 'Annual Report',
      isOutgoingLink: false,
      children: '',
    },
  ];

  return (
    <RelatedLinksStyled
      sectionId='related-links-2-financial-information-page'
      linkItems={linkItems}
      moduleName='related-links'
      moduleVariation='A'
      backgroundVariant='lightB'
      themeType='lightTheme'
      disableBottomPadding />
  );
};
